import i18next from "config/i18next";
import { VALIDATION_REGEX } from "utils/constants";
import * as yup from "yup";
import { filterPreliquidationValidationSchema } from "../types";

export const validationSchemaMX =
  (): yup.SchemaOf<filterPreliquidationValidationSchema> =>
    yup.object({
      presettlementId: yup
        .string()
        .min(
          5,
          i18next.t("filterPresettlements:presettlmentIdLengthError")
        )
        .matches(
          VALIDATION_REGEX.regNumber,
          i18next.t("validations:numbersOnly")
        ),
      fiscalNumber: yup
        .string()
        .matches(
          VALIDATION_REGEX.regRFC,
          i18next.t("validations:invalidFormat")
        )
    });
